import { lazy } from "react";
import type { RouteObject } from "react-router-dom";
import { RequirePermissions } from "@/app/router/guards";
import { PermissionCodes, RoleCodes } from "@/shared/auth/permissions";
import { LazyPage } from "@/app/router/LazyPage";

const SuppliersListPage = lazy(() =>
  import("@/modules/partners").then((m) => ({ default: m.SuppliersListPage })),
);
const SupplierDetailPage = lazy(() =>
  import("@/modules/partners").then((m) => ({ default: m.SupplierDetailPage })),
);
const PurchaseRequisitionsListPage = lazy(() =>
  import("@/modules/purchasing").then((m) => ({
    default: m.PurchaseRequisitionsListPage,
  })),
);
const PurchaseRequisitionDetailPage = lazy(() =>
  import("@/modules/purchasing").then((m) => ({
    default: m.PurchaseRequisitionDetailPage,
  })),
);
const PurchaseOrdersListPage = lazy(() =>
  import("@/modules/purchasing").then((m) => ({
    default: m.PurchaseOrdersListPage,
  })),
);
const PurchaseOrderDetailPage = lazy(() =>
  import("@/modules/purchasing").then((m) => ({
    default: m.PurchaseOrderDetailPage,
  })),
);

export const purchasingRoutes: RouteObject[] = [
          {
            element: <RequirePermissions codes={[PermissionCodes.PurchaseManage]} />,
            children: [
              {
                path: "pur/suppliers",
                element: (
                  <LazyPage>
                    <SuppliersListPage />
                  </LazyPage>
                ),
              },
              {
                path: "pur/suppliers/new",
                element: (
                  <LazyPage>
                    <SuppliersListPage />
                  </LazyPage>
                ),
              },
              {
                path: "pur/suppliers/:partnerCode/edit",
                element: (
                  <LazyPage>
                    <SupplierDetailPage />
                  </LazyPage>
                ),
              },
              {
                path: "pur/suppliers/:partnerCode",
                element: (
                  <LazyPage>
                    <SupplierDetailPage />
                  </LazyPage>
                ),
              },
            ],
          },
          {
            element: (
              <RequirePermissions
                codes={[
                  PermissionCodes.PurchaseRequisitionList, PermissionCodes.PurchaseRequest,
                  PermissionCodes.PurchaseOrderList, PermissionCodes.PurchaseManage,
                ]}
                match="any"
              />
            ),
            children: [
              {
                path: "pur/requisitions",
                element: (
                  <LazyPage>
                    <PurchaseRequisitionsListPage />
                  </LazyPage>
                ),
              },
              {
                path: "pur/requisitions/new",
                element: (
                  <LazyPage>
                    <PurchaseRequisitionsListPage />
                  </LazyPage>
                ),
              },
              {
                path: "pur/requisitions/:requisitionNo",
                element: (
                  <LazyPage>
                    <PurchaseRequisitionDetailPage />
                  </LazyPage>
                ),
              },
              {
                path: "pur/requisitions/:requisitionNo/edit",
                element: (
                  <LazyPage>
                    <PurchaseRequisitionDetailPage />
                  </LazyPage>
                ),
              },
              {
                path: "pur/orders",
                element: (
                  <LazyPage>
                    <PurchaseOrdersListPage />
                  </LazyPage>
                ),
              },
              {
                path: "pur/orders/new",
                element: (
                  <LazyPage>
                    <PurchaseOrdersListPage />
                  </LazyPage>
                ),
              },
              {
                path: "pur/orders/:orderNo/edit",
                element: (
                  <LazyPage>
                    <PurchaseOrderDetailPage />
                  </LazyPage>
                ),
              },
              {
                path: "pur/orders/:orderNo",
                element: (
                  <LazyPage>
                    <PurchaseOrderDetailPage />
                  </LazyPage>
                ),
              },
            ],
          },
];

export const purchasingFieldRoutes: RouteObject[] = [
  {
    element: (
      <RequirePermissions
        codes={[
          PermissionCodes.PurchaseRequisitionList,
          PermissionCodes.PurchaseRequest,
          PermissionCodes.PurchaseManage,
        ]}
        roles={[RoleCodes.NvSx, "ROLE_NV_SX"]}
        match="any"
      />
    ),
    children: [
      {
        path: "pur/requisitions",
        element: (
          <LazyPage>
            <PurchaseRequisitionsListPage />
          </LazyPage>
        ),
      },
      {
        path: "pur/requisitions/new",
        element: (
          <LazyPage>
            <PurchaseRequisitionsListPage />
          </LazyPage>
        ),
      },
      {
        path: "pur/requisitions/:requisitionNo",
        element: (
          <LazyPage>
            <PurchaseRequisitionDetailPage />
          </LazyPage>
        ),
      },
      {
        path: "pur/requisitions/:requisitionNo/edit",
        element: (
          <LazyPage>
            <PurchaseRequisitionDetailPage />
          </LazyPage>
        ),
      },
    ],
  },
];

